var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1666 7.02V5.83332C14.1666 2.61168 11.555 0 8.33332 0C5.11164 0 2.5 2.61168 2.5 5.83332V7.02C0.983359 7.68191 0.0021875 9.17855 0 10.8333V15.8333C0.00273437 18.1334 1.8666 19.9973 4.16664 20H12.5C14.8 19.9973 16.6639 18.1334 16.6666 15.8333V10.8333C16.6645 9.17855 15.6833 7.68191 14.1666 7.02ZM9.16664 14.1667C9.16664 14.6269 8.79356 15 8.33332 15C7.87309 15 7.5 14.6269 7.5 14.1667V12.5C7.5 12.0398 7.87309 11.6667 8.33332 11.6667C8.79356 11.6667 9.16664 12.0398 9.16664 12.5V14.1667ZM12.5 6.66668H4.16664V5.83336C4.16664 3.53219 6.03211 1.66668 8.33332 1.66668C10.6345 1.66668 12.5 3.53215 12.5 5.83336V6.66668Z",
    fill: "#586370"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lockIcon.a123c0fd11a1d6b147330f023f292e13.svg";
export { ForwardRef as ReactComponent };